var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('div',[_c('VuePlyr',{ref:"plyr",attrs:{"options":_vm.options}},[_c('audio',{ref:"audio",attrs:{"autoplay":_vm.active,"src":_vm.src,"preload":"metadata"},on:{"ended":_vm.donePlaying,"canplay":_vm.doneLoading}},[_vm._v("\n\n\t\t\t"+_vm._s(_vm.t('viewer', 'Your browser does not support audio.'))+"\n\t\t")])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }